import type { IOrderServices } from '~/processes/providers/authorization';


export interface ServiceStats {
  count: number;
  sum: number;
}

export interface ServicesByType {
  products: ServiceStats;    // Товары (tovar_type = "1")
  main: ServiceStats;       // Основные услуги
  repair: ServiceStats;     // Ремонтные услуги
  kit: ServiceStats;        // Комплектные услуги
}

/**
 * Определяет тип позиции
 */
export const getItemType = (item: IOrderServices): 'products' | 'main' | 'repair' | 'kit' => {
    if (item.tovar_type === '1') return 'products'; // Товары
    if (item.is_repair === '1') return 'repair';    // Ремонтные услуги
    if (item.is_serv_add === '1') return 'kit';     // Комплектные услуги
    return 'main';                                 // Основные услуги
};

/**
 * Рассчитывает статистику по типам позиций
 */
export const calculateOrderStats = (items: IOrderServices[]): ServicesByType => {
    const result: ServicesByType = {
        products: { count: 0, sum: 0 },
        main: { count: 0, sum: 0 },
        repair: { count: 0, sum: 0 },
        kit: { count: 0, sum: 0 },
    };

    items.forEach(item => {
        const itemType = getItemType(item);
        result[itemType].count += 1;
        result[itemType].sum += item.sum_service;
    });

    return result;
};

/**
 * Возвращает только услуги (исключая товары)
 */
export const getServicesCount = (items: IOrderServices[]): number => items.filter(item => item.tovar_type !== '1').length;